import React, { FC } from 'react'
import { MenuItem, MenuItemProps } from '@mui/material'

const EvtToolbar: FC<MenuItemProps> = ({ children, ...props }) => {
    return <MenuItem {...props}>{children}</MenuItem>
}

export default EvtToolbar
